export default __webpack_public_path__ + "static/media/admin-step3.1c7171d3.gif";